const updateValue = (key, value) => {
    return {type: 'UPDATE_VALUE', key: key, value: value};
};

export default updateValue;